module.exports = __webpack_public_path__ + "images/emoji/gemini.0b3deafaf23783ab2f82.png";